import { styled } from '@mui/material';
import { Button, Typography } from '@elements';
var StyledTypography = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: '0.5px'
  };
  return styles;
});
var StyledButton = styled(Button)(function (_ref2) {
  var theme = _ref2.theme,
      fullWidth = _ref2.fullWidth;
  var styles = {
    '&&': {
      padding: theme.spacing(0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: fullWidth ? '100%' : '40px',
      height: '40px',
      borderRadius: theme.typography.pxToRem(12),
      backgroundColor: theme.palette.internationalOrange.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.white.main,
      textTransform: 'uppercase',
      ':disabled': {
        backgroundColor: theme.palette.silverChalice.main,
        borderColor: theme.palette.silverChalice.main
      }
    }
  };
  return styles;
});
export { StyledButton, StyledTypography };